import type { GenericField } from '@Types';
import type { FieldPayload } from '@FormModule';
import { getPayloadDate } from '@Helpers';
import { payloadSanitizerHelper } from '@FormModule';

function getSanitizedFieldPerName({ name, value }: FieldPayload) {
  switch (name) {
    case 'date': {
      return {
        date: getPayloadDate(value, 'utc'),
      };
    }
    case 'amount': {
      return {
        _id: value._id,
        amount: value.amount,
        description: value.description,
      };
    }
  }
}

export default function (fields: Set<GenericField>) {
  let payload: { [key: string]: any } = {};
  const fieldNamesToBeSanitezed = ['amount', 'date'];

  fields.forEach((field: GenericField) => {
    const entry = payloadSanitizerHelper(field, fieldNamesToBeSanitezed, getSanitizedFieldPerName);
    payload = { ...payload, ...entry };
  });

  return payload;
}
